class nonBusinessDate {
    day: number;
    month: number;

    constructor(day: number, month: number) {
        this.day = day;
        this.month = month;
    }
}

export function isHoliday(date: Date): boolean {
    const MINIMUM_YEAR = 1701;
    const JANUARY = 0;
    const JUNE = 5;
    const DECEMBER = 11;

    const year = date.getFullYear();
    const month = date.getMonth();
    const dateOfMonth = date.getDate();

    // The Gregorian Calendar was taken in to use in Denmark in 1701.
    if (MINIMUM_YEAR >= year) {
        throw new Error(
            'The year ' + year + " is before Denmark's use of the Gregorian calendar (" + MINIMUM_YEAR + ').'
        );
    }

    // Static Holidays:
    // 01/01 - Nytårsdag, 05/06 - Grundlovsdag, 24/12 - Juleaften, 25/12 - 1. Juledag, 26/12 - 2. Juledag, 31/12 - Nytårsaften
    if (
        (month === JANUARY && dateOfMonth === 1) ||
        (month === JUNE && dateOfMonth === 5) ||
        (month === DECEMBER && dateOfMonth === 24) ||
        (month === DECEMBER && dateOfMonth === 25) ||
        (month === DECEMBER && dateOfMonth === 26) ||
        (month === DECEMBER && dateOfMonth === 31)
    ) {
        return true;
    } else {
        let nonBusinessDateList = loadNonStaticNonBusinessDays(year);
        for (let i = 0; i < nonBusinessDateList.length; i++) {
            if (month === nonBusinessDateList[i].month && dateOfMonth === nonBusinessDateList[i].day) {
                return true;
            }
        }
    }
    return false;
}

function loadNonStaticNonBusinessDays(year: number): nonBusinessDate[] {
    const WEEK_DAYS = 7;

    let easter: Date = calculateEaster(year);
    let nonBusinessDay: Date;
    let maundyThursday = new Date();
    let goodFriday = new Date();
    let easterDay = new Date();
    let greatPrayerDay = new Date();
    let christAscensionDay = new Date();
    let christAscensionAfterDay = new Date();
    let pentecostDay = new Date();

    // Skærtorsdag (3 days before Easter).
    nonBusinessDay = easter;
    nonBusinessDay.setDate(nonBusinessDay.getDate() - 3);
    maundyThursday.setFullYear(nonBusinessDay.getFullYear(), nonBusinessDay.getMonth(), nonBusinessDay.getDate());

    // Langfredag (1 day after Skærtorsdag).
    nonBusinessDay.setDate(nonBusinessDay.getDate() + 1);
    goodFriday.setFullYear(nonBusinessDay.getFullYear(), nonBusinessDay.getMonth(), nonBusinessDay.getDate());

    // 2. Påskedag (3 days after Langfredag).
    nonBusinessDay.setDate(nonBusinessDay.getDate() + 3);
    easterDay.setFullYear(nonBusinessDay.getFullYear(), nonBusinessDay.getMonth(), nonBusinessDay.getDate());

    // Stor Bededag (Falling on the 4th Friday after Easter - Calculated from 2. Påskedag).
    nonBusinessDay.setDate(nonBusinessDay.getDate() + 4 + WEEK_DAYS * 3);
    greatPrayerDay.setFullYear(nonBusinessDay.getFullYear(), nonBusinessDay.getMonth(), nonBusinessDay.getDate());

    // Kristi Himmelfart (6th Thursday after Easter).
    nonBusinessDay.setDate(nonBusinessDay.getDate() + 6 + WEEK_DAYS);
    christAscensionDay.setFullYear(nonBusinessDay.getFullYear(), nonBusinessDay.getMonth(), nonBusinessDay.getDate());

    // Dagen efter Kristi Himmelfart.
    nonBusinessDay.setDate(nonBusinessDay.getDate() + 1);
    christAscensionAfterDay.setFullYear(
        nonBusinessDay.getFullYear(),
        nonBusinessDay.getMonth(),
        nonBusinessDay.getDate()
    );

    // 2. Pinsedag (8th Monday after Easter).
    nonBusinessDay.setDate(nonBusinessDay.getDate() + 3 + WEEK_DAYS);
    pentecostDay.setFullYear(nonBusinessDay.getFullYear(), nonBusinessDay.getMonth(), nonBusinessDay.getDate());

    return [
        new nonBusinessDate(maundyThursday.getDate(), maundyThursday.getMonth()),
        new nonBusinessDate(goodFriday.getDate(), goodFriday.getMonth()),
        new nonBusinessDate(easterDay.getDate(), easterDay.getMonth()),
        new nonBusinessDate(greatPrayerDay.getDate(), greatPrayerDay.getMonth()),
        new nonBusinessDate(christAscensionDay.getDate(), christAscensionDay.getMonth()),
        new nonBusinessDate(christAscensionAfterDay.getDate(), christAscensionAfterDay.getMonth()),
        new nonBusinessDate(pentecostDay.getDate(), pentecostDay.getMonth()),
    ];
}

function calculateEaster(year: number): Date {
    let a = year % 19;
    let b = Math.floor(year / 100);
    let c = year % 100;
    let d = Math.floor(b / 4);
    let e = b % 4;
    let f = Math.floor((b + 8) / 25);
    let g = Math.floor((b - f + 1) / 3);
    let h = (19 * a + b - d - g + 15) % 30;
    let i = Math.floor(c / 4);
    let k = c % 4;
    let l = (32 + 2 * e + 2 * i - h - k) % 7;
    let m = Math.floor((a + 11 * h + 22 * l) / 451);
    let n = Math.floor((h + l - 7 * m + 114) / 31);
    let p = (h + l - 7 * m + 114) % 31;

    let result = new Date();
    result.setFullYear(year, n - 1, p + 1);

    return result;
}
